export const isJsonString = (stringParam: string) => {
  try {
    JSON.parse(stringParam);
    return true;
  } catch {
    return false;
  }
};
